/**
 * Bildlauf-Verhalten fuer `scrollBy`/`scrollIntoView`: weich, ausser die Person hat reduzierte
 * Bewegung eingestellt (WCAG 2.3.3). Die CSS-Regeln unter `prefers-reduced-motion` erreichen
 * einen Bildlauf aus JavaScript nicht, deshalb diese eine Stelle fuer alle Aufrufer.
 */
export function bildlaufVerhalten(): ScrollBehavior {
  // jsdom und alte Umgebungen kennen `matchMedia` nicht.
  if (typeof window.matchMedia !== 'function') return 'smooth';
  // `instant`, nicht `auto`: `auto` folgte einem `scroll-behavior: smooth` im CSS und liefe dann
  // doch weich (Codex-Gate PR #53).
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
}
